import React from 'react';
import CircleLoader from '~/editor/loader/CircleLoader';
import ImageItem from './ImageItem';
import NoResults from './NoResults';

export interface MediaFile {
  id: number;
  mediaUrl?: string;
  url?: string;
  thumbnail?: string;
  snapshotUrl?: string;
  pictureSnapshot?: string;
  screenshotUrl?: string;
  name?: string;
  internalName?: string;
  sourcePrompt?: string;
  width?: number;
  [key: string]: unknown;
}

interface MediaGridProps {
  files: MediaFile[];
  loading: boolean;
  type: 'image' | 'video' | 'document' | 'audio';
  variant?: 'small' | 'long';
  selectedId?: number;
  onSelect: (file: MediaFile) => void;
  onDelete?: (id: number) => void;
  loadMoreRef?: React.RefObject<HTMLDivElement>;
  showNoResults?: boolean;
  searchQuery?: string;
}

const MediaGrid: React.FC<MediaGridProps> = ({
  files,
  loading,
  type,
  variant = 'small',
  selectedId,
  onSelect,
  onDelete,
  loadMoreRef,
  showNoResults,
  searchQuery
}) => {
  return (
    <div className={`images ${loading ? 'loading' : variant}`}>
      {files?.map(file => (
        <ImageItem
          key={file.id}
          id={file.id}
          src={
            file?.screenshotUrl ||
            file?.thumbnail ||
            file?.snapshotUrl ||
            file?.mediaUrl ||
            file?.pictureSnapshot
          }
          selected={selectedId === file.id}
          onClick={() => onSelect(file)}
          onDelete={onDelete ? () => onDelete(file.id) : undefined}
          video={type === 'video'}
          file={file}
          type={type}
        />
      ))}
      {loading && <CircleLoader showText={true} />}
      <div className="weNeedToLoad" ref={loadMoreRef}></div>
      {!loading && showNoResults && <NoResults type={type} files={files} />}
    </div>
  );
};

export default MediaGrid;
